import React from 'react'

export default function Alert(props) {

    const newAlert = props.globalAlert
    if (!newAlert.hidden){
      window.scrollTo({top: 0, behavior: 'smooth'})
    }
    return(
      <div>
        {newAlert.hidden === false ? 
          (
            <div id="globalAlertID">
              <div id={newAlert.id} className={'pds-alert pds-alert-' + newAlert.type}>
                <div className="pds-card-section">
                  {newAlert.type === "success" ?
                      (
                        <i data-feather="check" className="pds-alert-type-icon" aria-hidden="true"></i>
                        ) : (
                          <i data-feather="x" className="pds-alert-type-icon" aria-hidden="true"></i>
                        )
                  }
                  <div className="pds-alert-content" role="alert">
                      <span className="sr-only">Success. </span>
                      {newAlert.message}
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <div>
            </div>
          )
        }
      <br/>
    </div>
    )
}